import React from "react";
import CustomCard from "../../components/cards/CustomCard";
import { Box, Divider, Flex } from "@chakra-ui/react";
import CustomText from "../../components/text/CustomText";
import GoldLine from "../../svgs/GoldLine";
import BgGradientLines from "../../assets/images/bg-lines.png";

function TicketSales() {
  return (
    <CustomCard>
      <Flex gap="16px" align="center">
        <CustomText text="Ticket Sales" wrap="nowrap" color="yess.base_black" />
        <Divider bg="#F2F2F2" />
      </Flex>
      <Flex flexDir="column" gap="8px" mt="24px">
        {TICKET_SALES.map((ticket, index) => (
          <Flex key={index} gap="12px" align="flex-start">
            <Box maxW="69px" w="100%">
              <CustomText
                text={ticket.title}
                color="yess.neutral700"
                size="10px"
                align="end"
                mt="3px"
              />
            </Box>
            <Flex
              w="100%"
              h="24px"
              borderRadius="4px"
              background={`url(${BgGradientLines}), rgba(242, 242, 242, 0.75)`}
              backgroundRepeat="no-repeat"
              backgroundSize="contain"
              backgroundPosition="right"
            >
              <Flex
                p="4px"
                bg="#e9e9e9"
                w={ticket.value}
                h="24px"
                borderRadius="4px"
                zIndex="10"
              >
                <Box bg="#2EC19E" borderRadius="4px" w="100%" />
              </Flex>
              <Box mt="5px" ml="-2px" zIndex="1">
                <GoldLine />
              </Box>
            </Flex>
            <Box maxW="22px" w="100%">
              <CustomText
                text={ticket.value}
                color="yess.neutral700"
                size="10px"
                mt="3px"
              />
            </Box>
          </Flex>
        ))}
      </Flex>
    </CustomCard>
  );
}

const TICKET_SALES = [
  {
    title: "VIP",
    value: "54%",
  },
  {
    title: "Regular",
    value: "27%",
  },
  {
    title: "Early Bird",
    value: "54%",
  },
  {
    title: "Student",
    value: "24%",
  },
  {
    title: "Family",
    value: "54%",
  },
  {
    title: "Exhibitor Pass",
    value: "73%",
  },
];

export default TicketSales;
